<template>
  <ApplicantForm :formLabel="'طلب جديد'" :formFields="formFields" :formData="formData"
   :nationalityId="formFields.nationalityId.value" :documents="documents" :submitType="'new'" :docsDisable="docsDisable"/>
  <alert-modal ref="alertModal" :redirectUrl="redirectTo" :alertContent="alertContent" :alertSubject="alertSubject"
    :isDismiss="false" :timeToEnable="6" />
</template>

<script>
import ApplicantForm from "@/components/Applicant/ApplicantForm";
import AlertModal from "@/components/AlertModal.vue";
import { Modal } from 'bootstrap';
import { mapGetters, mapActions } from 'vuex';
import imageCompression from 'browser-image-compression';

export default {
  data() {
    return {
      alertSubject: "",
      alertContent: "",
      redirectTo: "1",
      docsDisable: true,
      formFields: {
        applicantName: { id: 'ownerName', label: 'اسم السائق', type: 'text', tab: 'owner', value: null, placeholder: "الاسم مطابق لرخصة القيادة", required: "required" },
        phoneNo: { id: 'phoneNo', label: 'رقم الهاتف', type: 'text', tab: 'owner', value: null, required: "required" },
        nationNo: { id: 'nationNo', label: 'الرقم الوطني', type: 'text', tab: 'owner', value: (this.$route.params?.nationNo) ?? "", disabled: true, visibility: 1, }, // 0 => for non-Libyan, 1 => Libyan 
        appType: { id: 'appType', type: 'hidden', tab: 'owner', value: (this.$route.params?.appType) ?? null, disabled: true }, // 0 => for non-Libyan, 1 => Libyan 
        departId: {
          id: "departId",
          label: "المعبر",
          type: 'select',
          tab: 'owner',
          value: this.$route.params?.departId, 
          required: "required",
          options: [],
          optionName: "name",
          placeholder: "اختر المعبر",
        },
        nationalityId: {
          id: "nationalityId",
          label: "الجنسية",
          type: 'select',
          tab: 'owner',
          value: this.$route.params?.nationalityId, 
          required: "required",
          options: [],
          optionName: "name",
          placeholder: "اختر الجنسية",
          disabled: true,
        },
        cityId: {
          id: "city",
          label: "المدينة",
          type: 'select',
          tab: 'owner',
          value: null, required: "required",
          options: [],
          optionName: "name",
          placeholder: "اختر المدينة",
          visibility: 1, // 0 => for non-Libyan, 1 => Libyan 
        },
        cityText: { id: 'cityText', label: 'المدينة', type: 'text', tab: 'owner', value: null, placeholder: "المدينة أو المحافظة", required: "required", visibility: 0, }, // 0 => for non-Libyan, 1 => Libyan  
        address: { id: 'address', label: 'العنوان', type: 'text', tab: 'owner', value: null, placeholder: "العنوان (الحي أو الشارع)", required: "required" },
        passNo: { id: 'passportNumber', label: 'رقم الجواز', type: 'text', tab: 'owner', value: (this.$route.params?.passNo) ?? "", disabled: (this.$route.params?.passNo) ? true : false, required: "required" },
        passAutoNo: { id: 'passAutoNo', label: 'الرقم الآلي', type: 'text', tab: 'owner', value: null, placeholder:"الرقم الآلي في جواز السفر", visibility: 1, required: "required"  }, // 0 => for non-Libyan, 1 => Libyan 
        licenseNo: { id: 'licenseNo', label: 'رقم رخصة القيادة', type: 'text', tab: 'owner', value: null, required: "required" },
        transTypeId: {
          id: "transType",
          label: "نوع المركبة",
          type: 'select',
          tab: 'vehicle',
          value: (this.$route.params?.nationalityId != 1 /* 1 = ليبي */ && this.$route.params?.appType == 1/* 1 = خروج ليبيا */ ) ? 9 : "",
          required: "required",
          options: [],
          optionName: "name",
          placeholder: "اختر النوع",
        },
        madeId: {
          id: "made",
          label: "المُصنّع",
          type: 'select',
          tab: 'vehicle',
          value: null, required: "required",
          options: [],
          optionName: "name",
          placeholder: "اختر المُصنّع",
        },
        transModel: { id: 'transModel', label: 'طراز المركبة', type: 'text', tab: 'vehicle', value: null, placeholder:"(الصنف)", required: "required" },
        transColor: { id: 'transColor', label: 'لون السيارة', type: 'text', tab: 'vehicle', value: null, required: "required" },
        transDate: { id: 'transDate', label: 'تاريخ الصنع', type: 'text', tab: 'vehicle', value: null, required: "required" },
        engineNo: { id: 'engineNo', label: 'رقم المحرك', type: 'text', tab: 'vehicle', value: null, required: false },
        chassisNo: { id: 'chassisNo', label: 'رقم الهيكل', type: 'text', tab: 'vehicle', value: null, required: "required" },
        plateNo: { id: 'plateNo', label: 'رقم اللوحة', type: 'text', tab: 'vehicle', value: null, placeholder:"xx-xxxxx", required: "required" },
      },
      formData: {
        applicantName: "",
        phoneNo: "",
        nationNo: "",
        licenseNo: "",
        cityId: "",
        address: "",
        passNo: "",
        departId: "",
        transColor: "",
        transTypeId: "",
        madeId: "",
        transModel: "",
        engineNo: "",
        chassisNo: "",
        plateNo: "",
        transDate: "",
      },
      documents: [
        { name: "جواز السفر", file: null, preview: null, typeId: 1 },
        { name: "بطاقة شخصية", file: null, preview: null, typeId: 2 },
        { name: "رخصة القيادة", file: null, preview: null, typeId: 3 },
      ],
    };
  },
  computed: {
    ...mapGetters(['getDeparts', 'getTransTypes', 'getTransMades', 'getCities', 'getNationalities']),
    ...mapGetters('applicantFlow', ['getApplicant']),
    compTransTypeId: function() {
      // return this.formFields[11].value;
      return this.formFields.transTypeId.value;
    } 
  },
  async created() {
    await this.fetchOptions();
    if(this.getApplicant && this.getApplicant.hasOwnProperty('passNo')){
      Object.keys(this.formFields).forEach(key => {
        this.formFields[key].value = this.getApplicant[key] ?? this.formFields[key].value 
      });
    }else if(this.formFields.nationalityId.value != 1){
      if( this.formFields.appType.value == 1/* 1 = خروج ليبيا */){
        this.formFields.transTypeId.value = 9;
      }else{
        this.formFields.transTypeId.value = 3;
    }
    this.docsDisable = false;
    }
  },
  beforeUnmount() {
    this.$store.dispatch('applicantFlow/resetApplicant');
  },
  components: {
    ApplicantForm,
    AlertModal,
  },
  watch: {
    compTransTypeId: async function(v){
      await this.fetchDocs(v)
    } 
  },
  methods: {
    /** */
    async checkNationNo() {
            
            try {
                const response = await this.$axios.post("api/applicant/canaddnew", {NationNo: this.$route.params?.nationNo});
                const data = response.data;
                if(!data.isSuccess){
                    this.$router.push({ name: 'sign' })
                }
            } catch (error) {
                this.$tempAlert(error.response?.data.msg ?? "مشكلة في التصال",'warning');
                console.error("Error fetching options:", error);
            }
        },
    /********************************/
    /** */
    ...mapActions([
      'fetchDeparts',
      'fetchTransTypes',
      'fetchTransMades',
      'fetchCities',
      'fetchNationalities',
    ]),
    /********************************/
    /** */
    async fetchOptions() {
      // try {
      //   const [departs,cities, types, mades, docTypes] = await Promise.all([
      //     this.$axios.get("api/depart/getall"),
      //     this.$axios.get("api/city/getall"),
      //     this.$axios.get("api/trans/gettypes"),
      //     this.$axios.get("api/trans/getmades"),
      //     this.$axios.get("api/docs/gettypes"),
      //   ]);
        if (this.getDeparts.length == 0) {
          await this.fetchDeparts(); // Fetch and store in Vuex
        }
        if (this.getTransTypes.length == 0) {
          await this.fetchTransTypes();
        }
        if (this.getTransMades.length == 0) {
          await this.fetchTransMades();
        }
        if (this.getCities.length == 0) {
          await this.fetchCities();
        }
        if (this.getNationalities.length == 0) {
          await this.fetchNationalities();
        }
        if (this.formFields.transTypeId.value > 0) {
          await this.fetchDocs(this.formFields.transTypeId.value);
        }
        this.formFields.departId.options = this.getDeparts
        this.formFields.cityId.options = this.getCities
        this.formFields.transTypeId.options = this.getTransTypes
        this.formFields.madeId.options = this.getTransMades
        this.formFields.nationalityId.options = this.getNationalities
        this.documents.forEach((doc) => {
          doc['file'] = null;
          doc['preview'] = null;
        });
      // } catch (error) {
      //   if(error.response?.data){
      //     this.$tempAlert(error?.response.data.msg,'warning');
      //   }
      //   console.error("Error fetching options:", error);
      // }
    },
    /******************************/
    /** */
    async fetchDocs(v) {
      try {
        const response = await this.$axios.post("api/docs/getrequiredbytransid", {transId : v});
        if (response?.data.isSuccess) {
          this.documents = response?.data.docTypes;
          this.documents.forEach((doc) => {
          doc['file'] = null;
          doc['preview'] = null;
        });
        this.docsDisable = false
        } else {
          this.alertSubject = "فشل العملية";
          this.alertContent = response.data.msg;
        }
      } catch (error) {
        if(error.response?.data){
          this.$tempAlert(error.response.data.msg,'warning');
        }
        console.error("Submission error:", error);
      }
    },

    /******************************/
    /** */
    async submitForm() {
      
      // this.startLoading();
      const formData = new FormData();
      Object.keys(this.formFields).forEach((key) => {
                if(this.formFields[key].value == null){
                  this.formFields[key].value = "";
                }
                formData.append(key, (typeof(this.formFields[key].value) == 'string') ? this.formFields[key].value.trim() : this.formFields[key].value);
            });
      this.documents.forEach(doc => {
        if (doc.file) {
          formData.append('DocImages', doc.file);
          formData.append('DocTypes', doc.id);
        }
      });
      // const formDataObj = {};
      //   formData.forEach((value, key) => (formDataObj[key] = value));
      //   console.log("formData", formDataObj)
      
      try {
        const response = await this.$axios.post("api/applicant/addnew", formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if (response.data.isSuccess) {
          this.alertSubject = "تمت الإضافة بنجاح";
          this.alertContent = "رقم التسجيل : " + response.data.applicant.id + "<br/> رقم التحقق : " + response.data.applicant.checkNo + "<br/> <span class=''> قم بحفظ الأرقام لاستحدامها لحقاً </span>";
        } else {
          this.alertSubject = "فشل العملية";
          this.alertContent = response.data.msg;
          this.redirectTo = '0';
        }
        // Trigger the modal display
        const alertModalInstance = new Modal(this.$refs.alertModal.$el);
        alertModalInstance.show();
        this.$refs.alertModal.isHidden = 0; // Start the timer
      } catch (error) {
        if(error.response?.data){
          this.$tempAlert(error.response.data.msg,'warning');
          var emsg = {
            msg: "",
            interval : 4000
          };
          error.response.data.errors.forEach((e)=>{
            emsg.msg += e+ "<br/>";
            emsg.interval += 2000;
          })
          setTimeout(()=>{
            this.$tempAlert(emsg.msg,'warning', emsg.interval);
          },1000)
        }
        console.error("Submission error:", error);
      } /* finally {
        this.stopLoading();
      } */
    },
  },
};
</script>

<style>
.form-container {
  background: #fff;
  padding-left: 11px;
  padding-right: 11px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  /* width: 60vw; */
  margin: auto;
}

.thumbnail {
  max-width: 70vw;
  height: 37vh;
  object-fit: cover;
  margin-top: 10px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
</style>
